var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "b-link",
        {
          staticClass: "mt-3 btn btn-lg btn-success",
          staticStyle: { width: "100%" },
          attrs: { to: "/informasi" },
        },
        [_c("i", { staticClass: "fa fa-list" }), _vm._v(" Informasi")]
      ),
      _vm._v(" "),
      _c(
        "b-link",
        {
          staticClass: "mt-3 btn btn-lg btn-success",
          staticStyle: { width: "100%" },
          attrs: { to: "/pengumuman" },
        },
        [_c("i", { staticClass: "fa fa-info-circle" }), _vm._v(" Pengumuman")]
      ),
      _vm._v(" "),
      _c(
        "b-link",
        {
          staticClass: "mt-3 btn btn-lg btn-success",
          staticStyle: { width: "100%" },
          attrs: { to: "/pendaftaran" },
        },
        [
          _vm._v("Daftar Online "),
          _c("i", { staticClass: "fa fa-arrow-right" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }